import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useSuggestionUtils() {
    var _a = React.useState(), suggestionElement = _a[0], setSuggestionElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        var _a;
        if (!client || suggestionElement)
            return;
        var loadedSuggestionElement = (_a = client.getSuggestionElement) === null || _a === void 0 ? void 0 : _a.call(client);
        if (loadedSuggestionElement) {
            setSuggestionElement(loadedSuggestionElement);
        }
    }, [client, setSuggestionElement, suggestionElement]);
    return suggestionElement;
}
export function useSuggestionModeState() {
    var suggestionElement = useSuggestionUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.isSuggestionModeEnabled$))
            return;
        var subscription = suggestionElement.isSuggestionModeEnabled$().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.isSuggestionModeEnabled$]);
    return data;
}
export function useSuggestions(filter) {
    var suggestionElement = useSuggestionUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedFilter = React.useMemo(function () {
        return filter;
    }, [JSON.stringify(filter)]);
    useEffect(function () {
        if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.getSuggestions$))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = suggestionElement.getSuggestions$(memoizedFilter)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.getSuggestions$, memoizedFilter]);
    return data;
}
export function usePendingSuggestion(targetId) {
    var suggestionElement = useSuggestionUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedTargetId = React.useMemo(function () { return targetId; }, [targetId]);
    useEffect(function () {
        if (!(suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.getPendingSuggestion$))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = suggestionElement.getPendingSuggestion$(memoizedTargetId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [suggestionElement === null || suggestionElement === void 0 ? void 0 : suggestionElement.getPendingSuggestion$, memoizedTargetId]);
    return data;
}
